import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1","key":"svg-1"}],["path",{"d":"M11.5 7.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-2"}]]

const IconAccessible = createReactComponent('outline', 'accessible', 'Accessible', __iconNode);

export default IconAccessible;